import * as React from 'react';

import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';

import { GeneralSiteSettingsSubspaceState } from '../../../../app/spaces/SiteSettingsSpace/GeneralSiteSettingsSubspace';
import { getSessionManagementServiceInstance } from '../../../../sessionManagement/SessionManagementService';
import { coordinatorSubmitFailedHandler, coordinatorSubmitHandler } from '../common/GeneralToastHandlers';
import ReactSiteSettingsForServerAdmin from './ReactSiteSettingsForServerAdminSubFormik';
import { ReactSiteSettingsForSiteAdmin } from './ReactSiteSettingsForSiteAdminSubFormik';

/**
 * Creates a settings coordinator with the site settings for site admin and site settings for server admin forms
 */
export function GeneralSiteSettingsCoordinator(props: GeneralSiteSettingsSubspaceState) {
  const sessionManagementService = getSessionManagementServiceInstance();

  const shouldRenderServerAdminForm = sessionManagementService.isSessionServerAdmin();
  const shouldRenderSiteAdminForm = sessionManagementService.isSessionServerAdmin()
    || (sessionManagementService.isSessionSiteAdmin() && sessionManagementService.isOnlineEnvironment());

  return (
    <SettingsCoordinator
      onSubmit={coordinatorSubmitHandler}
      onSubmitFailure={coordinatorSubmitFailedHandler}
      submitSequentially = {true}>

      {shouldRenderServerAdminForm &&
      <ReactSiteSettingsForServerAdmin settings={props}/>}

      {shouldRenderSiteAdminForm &&
      <ReactSiteSettingsForSiteAdmin settings={props}/>}

    </SettingsCoordinator>
  );
}
